"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testRefs = void 0;
const testRefs = {
    // Navigation
    NAV_SHOP: 'NAV_SHOP',
    NAV_READ: 'NAV_READ',
    NAV_VISIT: 'NAV_VISIT',
    NAV_SEARCH: 'NAV_SEARCH',
    NAV_LOGIN: 'NAV_LOGIN',
    NAV_CART: 'NAV_CART',
    NAV_LOGO: 'NAV_LOGO',
    NAV_LIVE_ASSISTANCE: 'NAV_LIVE_ASSISTANCE',
    NAV_SHOP_1: 'NAV_SHOP_1',
    NAV_SHOP_2: 'NAV_SHOP_2',
    NAV_SHOP_PRODUCT_RADIO: 'NAV_SHOP_PRODUCT_RADIO',
    NAV_VISIT_INPUT: 'NAV_VISIT_INPUT',
    NAV_VISIT_CHECKBOX: 'NAV_VISIT_CHECKBOX',
    NAV_CLOSE_VISIT_2: 'NAV_CLOSE_VISIT_2',
    // Footer
    FOOTER_LINK: 'FOOTER_LINK',
    FOOTER_NEWSLETTER_CHECKBOX: 'FOOTER_NEWSLETTER_CHECKBOX',
    FOOTER_PRIVACY_POLICY_LINK: 'FOOTER_PRIVACY_POLICY_LINK',
    FOOTER_NEWSLETTER_COPY: 'FOOTER_NEWSLETTER_COPY',
    FOOTER_TERMS_CHECKBOX: 'FOOTER_TERMS_CHECKBOX',
    FOOTER_TERMS_CONDITIONS_TEXTBOX: 'FOOTER_TERMS_CONDITIONS_TEXTBOX',
    // Cart
    ADD_TO_CART: 'ADD_TO_CART',
    CART_CHECKOUT_CTA: 'CART_CHECKOUT_CTA',
    CART_PROMO_CTA: 'CART_PROMO_CTA',
    CART_PROMO_INPUT: 'CART_PROMO_INPUT',
    CART_PROMO_AMOUNT: 'CART_PROMO_AMOUNT',
    CART_HEADING: 'CART_HEADING',
    CART_CLOSE: 'CART_CLOSE',
    CART_OFFER_MESSAGE: 'CART_OFFER_MESSAGE',
    CART_SUBTOTAL: 'CART_SUBTOTAL',
    CART_PAYMENT_ICONS: 'CART_PAYMENT_ICONS',
    CART_PAYMENT_OPTION_MESSAGE: 'CART_PAYMENT_OPTION_MESSAGE',
    CART_SUMMARY_WRAPPER: 'CART_SUMMARY_WRAPPER',
    // Checkout
    CHECKOUT_AGE_VERIFICATION_CHECKBOX: 'CHECKOUT_AGE_VERIFICATION_CHECKBOX',
    CHECKOUT_COLLECT_CURRENT_LOCATION_BUTTON: 'CHECKOUT_COLLECT_CURRENT_LOCATION_BUTTON',
    CHECKOUT_COLLECT_EDIT_STORE_BUTTON: 'CHECKOUT_COLLECT_EDIT_STORE_BUTTON',
    CHECKOUT_CUSTOMER_EMAIL: 'CHECKOUT_CUSTOMER_EMAIL',
    CHECKOUT_COLLECT_CONTINUE_TO_PAYMENT_METHOD_BUTTON: 'CHECKOUT_COLLECT_CONTINUE_TO_PAYMENT_METHOD_BUTTON',
    CHECKOUT_COLLECT_SEARCH_STORE_INPUT: 'CHECKOUT_COLLECT_SEARCH_STORE_INPUT',
    CHECKOUT_COLLECT_SELECT_STORE_LINK: 'CHECKOUT_COLLECT_SELECT_STORE_LINK',
    CHECKOUT_COLLECT_SEE_MORE_STORES_LINK: 'CHECKOUT_COLLECT_SEE_MORE_STORES_LINK',
    CHECKOUT_CUSTOMER_PASSWORD: 'CHECKOUT_CUSTOMER_PASSWORD',
    CHECKOUT_CUSTOMER_PREFIX: 'CHECKOUT_CUSTOMER_PREFIX',
    CHECKOUT_CUSTOMER_FIRST_NAME: 'CHECKOUT_CUSTOMER_FIRST_NAME',
    CHECKOUT_CUSTOMER_LAST_NAME: 'CHECKOUT_CUSTOMER_LAST_NAME',
    CHECKOUT_CUSTOMER_SUBMIT: 'CHECKOUT_CUSTOMER_SUBMIT',
    CHECKOUT_CUSTOMER_GUEST_BUTTON: 'CHECKOUT_CUSTOMER_GUEST_BUTTON',
    CHECKOUT_EDIT_CART: 'CHECKOUT_EDIT_CART',
    CHECKOUT_FULFILMENT_METHOD: 'CHECKOUT_FULFILMENT_METHOD',
    CHECKOUT_FULFILMENT_SUBMIT: 'CHECKOUT_FULFILMENT_SUBMIT',
    ADDRESS_COUNTRY: 'ADDRESS_COUNTRY',
    ADDRESS_LINE_1: 'ADDRESS_LINE_1',
    ADDRESS_LINE_2: 'ADDRESS_LINE_2',
    ADDRESS_COMPANY: 'ADDRESS_COMPANY',
    ADDRESS_REGION: 'ADDRESS_REGION',
    ADDRESS_TOWN: 'ADDRESS_TOWN',
    ADDRESS_POSTAL_CODE: 'ADDRESS_POSTAL_CODE',
    ADDRESS_COUNTRY_CODE: 'ADDRESS_COUNTRY_CODE',
    ADDRESS_PHONE_NUMBER: 'ADDRESS_PHONE_NUMBER',
    ADDRESS_ZIP_BTN: 'ADDRESS_ZIP_BTN',
    CHECKOUT_SHIPPING_METHOD: 'CHECKOUT_SHIPPING_METHOD',
    CHECKOUT_GIFT: 'CHECKOUT_GIFT',
    CHECKOUT_GIFT_MESSAGE_CHECKBOX: 'CHECKOUT_GIFT_MESSAGE_CHECKBOX',
    CHECKOUT_GIFT_MESSAGE: 'CHECKOUT_GIFT_MESSAGE',
    CHECKOUT_GIFT_INSTRUCTIONS_CHECKBOX: 'CHECKOUT_GIFT_INSTRUCTIONS_CHECKBOX',
    CHECKOUT_GIFT_INSTRUCTIONS: 'CHECKOUT_GIFT_INSTRUCTIONS',
    CHECKOUT_REQUEST_ADDON_CHECKBOX: 'CHECKOUT_REQUEST_ADDON_CHECKBOX',
    CHECKOUT_REQUEST_ADDON_INSTRUCTIONS: 'CHECKOUT_REQUEST_ADDON_INSTRUCTIONS',
    CHECKOUT_SHIPPING_SUBMIT: 'CHECKOUT_SHIPPING_SUBMIT',
    CHECKOUT_PAYMENT_METHOD: 'CHECKOUT_PAYMENT_METHOD',
    CHECKOUT_PAYMENT_CARD_HOLDER: 'CHECKOUT_PAYMENT_CARD_HOLDER',
    CHECKOUT_PAYMENT_CARD: 'CHECKOUT_PAYMENT_CARD',
    CHECKOUT_PAYMENT_EXPIRATION: 'CHECKOUT_PAYMENT_EXPIRATION',
    CHECKOUT_PAYMENT_CVC: 'CHECKOUT_PAYMENT_CVC',
    CHECKOUT_PAYMENT_GIFTCARD_CODE: 'CHECKOUT_PAYMENT_GIFTCARD_CODE',
    CHECKOUT_PAYMENT_GIFTCARD_PIN: 'CHECKOUT_PAYMENT_GIFTCARD_PIN',
    CHECKOUT_BILLING_SAME_SHIPPING: 'CHECKOUT_BILLING_SAME_SHIPPING',
    CHECKOUT_BILLING_TAX: 'CHECKOUT_BILLING_TAX',
    CHECKOUT_PAYMENT_SUBMIT: 'CHECKOUT_PAYMENT_SUBMIT',
    CHECKOUT_SAMPLES_RADIO: 'CHECKOUT_SAMPLES_RADIO',
    CHECKOUT_SAMPLES_SUBMIT: 'CHECKOUT_SAMPLES_SUBMIT',
    CHECKOUT_REVIEW_TOTAL: 'CHECKOUT_REVIEW_TOTAL',
    CHECKOUT_REVIEW_TOS_CHECKBOX: 'CHECKOUT_REVIEW_TOS_CHECKBOX',
    CHECKOUT_REVIEW_SUBMIT: 'CHECKOUT_REVIEW_SUBMIT',
    CHECKOUT_REVIEW_TERMS_CONDITIONS: 'CHECKOUT_REVIEW_TERMS_CONDITIONS',
    CHECKOUT_SAVED_CARD_OPTION: 'CHECKOUT_SAVED_CARD_OPTION',
    CHECKOUT_SAVED_CARD_CANCEL: 'CHECKOUT_SAVED_CARD_CANCEL',
    CHECKOUT_SAVED_CARD_CONFIRM: 'CHECKOUT_SAVED_CARD_CONFIRM',
    CHECKOUT_SAVED_CARD_DELETE: 'CHECKOUT_SAVED_CARD_DELETE',
    CHECKOUT_SAVED_CARD_SET_PREFERRED: 'CHECKOUT_SAVED_CARD_SET_PREFERRED',
    CHECKOUT_CHANGE_METHOD: 'CHECKOUT_CHANGE_METHOD',
    // Confirmation
    CONFIRMATION_ACCOUNT_BUTTON: 'CONFIRMATION_ACCOUNT_BUTTON',
    // Sign up
    SIGNUP_TERMS_CHECKBOX: 'SIGNUP_TERMS_CHECKBOX',
    SIGNUP_AGE_VERIFICATION_CHECKBOX: 'SIGNUP_AGE_VERIFICATION_CHECKBOX',
    SIGNUP_MARKETING_SUBSCRIPTIONN_CHECKBOX: 'SIGNUP_MARKETING_SUBSCRIPTIONN_CHECKBOX',
    SIGNUP_TERMS_CONDITIONS_TEXTBOX: 'SIGNUP_TERMS_CONDITIONS_TEXTBOX',
    SIGNUP_PRIVACY_POLICY_VERIFICATION_TEXTBOX: 'SIGNUP_PRIVACY_POLICY_VERIFICATION_TEXTBOX',
    BREADCRUMBS_CATEGORY: 'BREADCRUMBS_CATEGORY',
    BREADCRUMBS_SUBCATEGORY: 'BREADCRUMBS_SUBCATEGORY',
    PDP_BREADCRUMBS_CATEGORY: 'PDP_BREADCRUMBS_CATEGORY',
    PDP_BREADCRUMBS_SUBCATEGORY: 'PDP_BREADCRUMBS_SUBCATEGORY',
    // Category filter
    CATEGORY_OPEN_FILTER: 'CATEGORY_OPEN_FILTER',
    CATEGORY_CLOSE_FILTER: 'CATEGORY_CLOSE_FILTER',
    CATEGORY_CLEAR_FILTER: 'CATEGORY_CLEAR_FILTER',
    CATEGORY_DONE_FILTER: 'CATEGORY_DONE_FILTER',
    CATEGORY_OPEN_TYPES_FILTER: 'CATEGORY_OPEN_TYPES_FILTER',
    CATEGORY_FILTER_CHECKBOX: 'CATEGORY_FILTER_CHECKBOX',
    CATEGORY_FILTER_BUTTON: 'CATEGORY_FILTER_BUTTON',
    NAV_CATEGORY: 'NAV_CATEGORY',
    // Content Hub Load More Button
    CONTENT_HUB_LOAD_MORE_BUTTON: 'CONTENT_HUB_LOAD_MORE_BUTTON',
    // Slices
    SLICE_PRODUCT_FIFTY_FIFTY_TYPE_PRODUCT_EXTRACT_LINK: 'SLICE_PRODUCT_FIFTY_FIFTY_TYPE_PRODUCT_EXTRACT_LINK',
    // My Account
    MY_ACCOUNT_COMMUNICATIONS_PRIVACY_POLICY: 'MY_ACCOUNT_COMMUNICATIONS_PRIVACY_POLICY',
    // PDP
    PDP_BACK_IN_STOCK_NOTIFICATION_BUTTON: 'PDP_BACK_IN_STOCK_NOTIFICATION_BUTTON',
    // Order confirmation page- Feedback widget
    SUBMIT_FEEDBACK: 'FEEDBACK_WIDGET_SUBMIT_FEEDBACK_BUTTON',
    // Alert Banner
    ALERT_BANNER_PROMOTION_CTA: 'ALERT_BANNER_PROMOTION_CTA',
};
exports.testRefs = testRefs;
//# sourceMappingURL=testRefs.js.map